import type { ComponentProps, ComponentType } from "react";
import {
  IconAlertTriangle,
  IconArrowBackUp,
  IconArrowForwardUp,
  IconArrowLeft,
  IconArrowRight,
  IconCalendar,
  IconBulb,
  IconBrandGithub,
  IconBrandGoogle,
  IconCheck,
  IconChevronDown,
  IconChevronUp,
  IconClock,
  IconCurrentLocation,
  IconCoin,
  IconDots,
  IconDownload,
  IconExternalLink,
  IconHome,
  IconMap2,
  IconMenu2,
  IconPencil,
  IconPlus,
  IconPrinter,
  IconRefresh,
  IconRoute,
  IconSearch,
  IconSparkles,
  IconTrash,
  IconLock,
  IconCloud,
  IconLogin2,
  IconLogout2,
  IconShieldLock,
  IconUser,
  IconX,
} from "@tabler/icons-react";

export type IconName =
  | "arrow-left"
  | "arrow-right"
  | "calendar"
  | "bulb"
  | "github"
  | "google"
  | "check"
  | "chevron-down"
  | "chevron-up"
  | "clock"
  | "cloud"
  | "coin"
  | "download"
  | "edit"
  | "external"
  | "home"
  | "map"
  | "menu"
  | "more"
  | "locate"
  | "login"
  | "logout"
  | "lock"
  | "plus"
  | "redo"
  | "refresh"
  | "route"
  | "search"
  | "shield"
  | "spark"
  | "trash"
  | "undo"
  | "user"
  | "warning"
  | "print"
  | "x";

interface IconProps extends Omit<ComponentProps<typeof IconRoute>, "ref"> {
  name: IconName;
  size?: number;
}

const icons: Record<IconName, ComponentType<ComponentProps<typeof IconRoute>>> = {
  "arrow-left": IconArrowLeft,
  "arrow-right": IconArrowRight,
  calendar: IconCalendar,
  bulb: IconBulb,
  github: IconBrandGithub,
  google: IconBrandGoogle,
  check: IconCheck,
  "chevron-down": IconChevronDown,
  "chevron-up": IconChevronUp,
  clock: IconClock,
  cloud: IconCloud,
  coin: IconCoin,
  download: IconDownload,
  edit: IconPencil,
  external: IconExternalLink,
  home: IconHome,
  map: IconMap2,
  menu: IconMenu2,
  more: IconDots,
  locate: IconCurrentLocation,
  login: IconLogin2,
  logout: IconLogout2,
  lock: IconLock,
  plus: IconPlus,
  redo: IconArrowForwardUp,
  refresh: IconRefresh,
  route: IconRoute,
  search: IconSearch,
  shield: IconShieldLock,
  spark: IconSparkles,
  trash: IconTrash,
  undo: IconArrowBackUp,
  user: IconUser,
  warning: IconAlertTriangle,
  print: IconPrinter,
  x: IconX,
};

export function Icon({ name, size = 18, stroke = 1.8, ...props }: IconProps) {
  const Component = icons[name];
  return <Component aria-hidden="true" size={size} stroke={stroke} {...props} />;
}
